/* Action Types */
export const SAVE_ITEM_FAIL = 'la/user/saveItem/FAIL';
export const SAVE_ITEM_REQUEST = 'la/user/saveItem/REQUEST';
export const SAVE_ITEM_SUCCESS = 'la/user/saveItem/SUCCESS';

export const UNSAVE_ITEM_FAIL = 'la/user/unsaveItem/FAIL';
export const UNSAVE_ITEM_REQUEST = 'la/user/unsaveItem/REQUEST';
export const UNSAVE_ITEM_SUCCESS = 'la/user/unsaveItem/SUCCESS';

export const LOAD_SAVED_ITEMS_FAIL = 'LOAD_SAVED_ITEMS_FAIL';
export const LOAD_SAVED_ITEMS_REQUEST = 'LOAD_SAVED_ITEMS_REQUEST';
export const LOAD_SAVED_ITEMS_SUCCESS = 'LOAD_SAVED_ITEMS_SUCCESS';
